// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Moment = require("moment");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Modal$ReactHooksTemplate = require("./Modal.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");
var ModalFormLayout$ReactHooksTemplate = require("./ModalFormLayout.res.js");
var OrganizationProfile$ReactHooksTemplate = require("../settings/organizationProfile.res.js");
var SurveyPreviewWrapper$ReactHooksTemplate = require("./SurveyPreviewWrapper.res.js");

function decodeSurvey(json) {
  var partial_arg = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.empty, undefined);
  var partial_arg$1 = function (param) {
    return Json_decode.withDefault(partial_arg, DomainModel$ReactHooksTemplate.$$String.Email.decode, param);
  };
  return {
          id: Json_decode.field("id", Json_decode.$$int, json),
          name: Json_decode.field("name", Json_decode.string, json),
          updatedAt: Moment(new Date(Json_decode.field("updated_at", Json_decode.string, json))),
          createdBy: Json_decode.field("creator", (function (param) {
                  return Json_decode.field("email", partial_arg$1, param);
                }), json)
        };
}

function SurveyCreate(props) {
  var projectId = props.projectId;
  var toggleSurveyCreate = props.toggleSurveyCreate;
  var match = React.useState(function (param) {
        return Survey$ReactHooksTemplate.empty();
      });
  var setSurvey = match[1];
  var survey = match[0];
  var match$1 = React.useState(function (param) {
        return OrganizationProfile$ReactHooksTemplate.empty();
      });
  var setClient = match$1[1];
  var match$2 = React.useState(function (param) {
        return /* [] */0;
      });
  var setSurveyTemplates = match$2[1];
  var match$3 = React.useState(function (param) {
        return false;
      });
  var setTemplatePage = match$3[1];
  var templatePage = match$3[0];
  var match$4 = React.useState(function (param) {
        return Survey$ReactHooksTemplate.empty();
      });
  var setSelectedTemplate = match$4[1];
  var selectedTemplate = match$4[0];
  var match$5 = React.useState(function (param) {
        return false;
      });
  var setTemplate = match$5[1];
  var match$6 = React.useState(function (param) {
        return false;
      });
  var setShowPreview = match$6[1];
  var showPreview = match$6[0];
  var match$7 = React.useState(function (param) {
        return "";
      });
  var setErrors = match$7[1];
  var match$8 = React.useState(function (param) {
        return false;
      });
  var setNameError = match$8[1];
  var nameError = match$8[0];
  var containsInvalidChar = function (specialCharRegex, words) {
    return List.exists((function (word) {
                  return List.exists((function (x) {
                                return Caml_obj.equal(word, x);
                              }), specialCharRegex);
                }), words);
  };
  var handleNameChange = function (e) {
    var name = e.target.value;
    var words = Belt_List.fromArray(Js_string.split("", name));
    var error = containsInvalidChar({
          hd: "<",
          tl: {
            hd: "!",
            tl: {
              hd: "=",
              tl: {
                hd: "+",
                tl: {
                  hd: "-",
                  tl: {
                    hd: "@",
                    tl: {
                      hd: ">",
                      tl: {
                        hd: "?",
                        tl: {
                          hd: "'",
                          tl: {
                            hd: "\"",
                            tl: {
                              hd: "$",
                              tl: {
                                hd: "#",
                                tl: {
                                  hd: "%",
                                  tl: {
                                    hd: "^",
                                    tl: {
                                      hd: "*",
                                      tl: {
                                        hd: "(",
                                        tl: {
                                          hd: ")",
                                          tl: {
                                            hd: "/",
                                            tl: {
                                              hd: ".",
                                              tl: {
                                                hd: "&",
                                                tl: {
                                                  hd: ",",
                                                  tl: {
                                                    hd: ";",
                                                    tl: {
                                                      hd: "`",
                                                      tl: {
                                                        hd: "~",
                                                        tl: /* [] */0
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }, words);
    Curry._1(setNameError, (function (param) {
            return error;
          }));
    Curry._1(setSurvey, (function (prev) {
            return Survey$ReactHooksTemplate.setName(prev, name);
          }));
  };
  var togglePreview = function (param) {
    Curry._1(setShowPreview, (function (param) {
            return !showPreview;
          }));
  };
  var match$9 = Survey$ReactHooksTemplate.category(survey);
  var isQuizModeActive;
  isQuizModeActive = match$9 === "Normal" ? false : true;
  var handleCategoryToggle = function (param) {
    Curry._1(setSurvey, (function (prevSurvey) {
            var match = Survey$ReactHooksTemplate.category(prevSurvey);
            var tmp;
            tmp = match === "Normal" ? "Quiz" : "Normal";
            return Survey$ReactHooksTemplate.setCategory(prevSurvey, tmp);
          }));
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (surveys) {
                  return Promise.resolve(Curry._1(setSurveyTemplates, (function (param) {
                                    return surveys;
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/template_list", (function (param) {
                      return Json_decode.field("surveys", (function (param) {
                                    return Json_decode.list(Survey$ReactHooksTemplate.fromJson, param);
                                  }), param);
                    })));
          Js_promise.then_((function (organization) {
                  return Promise.resolve(Curry._1(setClient, (function (param) {
                                    return organization;
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/organization_profiles/0", (function (param) {
                      return Json_decode.field("organization_profile", OrganizationProfile$ReactHooksTemplate.decode, param);
                    })));
        }), []);
  var randomBgColor = function (param) {
    return Belt_Array.getExn(Belt_Array.shuffle($$Array.of_list({
                        hd: "bg-lemonchifon",
                        tl: {
                          hd: "bg-azureishwhite",
                          tl: {
                            hd: "bg-azureishwhitesolid",
                            tl: {
                              hd: "bg-brightgray",
                              tl: /* [] */0
                            }
                          }
                        }
                      })), 0);
  };
  var chooseTemplate = function (template, preview) {
    if (preview === true) {
      Curry._1(setTemplate, (function (param) {
              return true;
            }));
      return Curry._1(setSelectedTemplate, (function (param) {
                    return template;
                  }));
    } else if (Survey$ReactHooksTemplate.id(selectedTemplate) === Survey$ReactHooksTemplate.id(template)) {
      Curry._1(setTemplate, (function (param) {
              return false;
            }));
      return Curry._1(setSelectedTemplate, (function (param) {
                    return Survey$ReactHooksTemplate.empty();
                  }));
    } else {
      Curry._1(setTemplate, (function (param) {
              return true;
            }));
      return Curry._1(setSelectedTemplate, (function (param) {
                    return template;
                  }));
    }
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Modal$ReactHooksTemplate.make, {
                      show: showPreview,
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(SurveyPreviewWrapper$ReactHooksTemplate.make, {
                                        survey: selectedTemplate,
                                        client: match$1[0]
                                      }),
                                  className: ""
                                }),
                            className: "w-screen bg-white pt-6"
                          }),
                      handleClose: (function (param) {
                          togglePreview();
                        })
                    }),
                JsxRuntime.jsx(ModalFormLayout$ReactHooksTemplate.Shell.make, {
                      body: templatePage ? JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h3", {
                                      children: "Explore Survey Library",
                                      className: "text-base font-semibold text-darkcharcoal mb-4"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: $$Array.of_list(Belt_List.map(match$2[0], (function (template) {
                                                  return JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("div", {
                                                                      children: template.name,
                                                                      className: "flex justify-center px-6 py-10 font-semibold text-sm sm:text-base " + randomBgColor(),
                                                                      onClick: (function (param) {
                                                                          chooseTemplate(template, false);
                                                                        })
                                                                    }),
                                                                JsxRuntime.jsxs("div", {
                                                                      children: [
                                                                        JsxRuntime.jsx("span", {
                                                                              children: "Modified " + Belt_Option.getWithDefault(template.updatedAt, Moment()).format("ll"),
                                                                              className: "truncate"
                                                                            }),
                                                                        JsxRuntime.jsx("button", {
                                                                              children: JsxRuntime.jsx("img", {
                                                                                    className: "h-4 w-4",
                                                                                    alt: "",
                                                                                    src: Image$ReactHooksTemplate.previewEye
                                                                                  }),
                                                                              "aria-label": "Preview template",
                                                                              className: "flex-shrink-0 p-1.5 rounded hover:bg-gray-100 focus:outline-none",
                                                                              type: "button",
                                                                              onClick: (function (e) {
                                                                                  e.stopPropagation();
                                                                                  chooseTemplate(template, true);
                                                                                  togglePreview();
                                                                                })
                                                                            })
                                                                      ],
                                                                      className: "bg-white text-aurometalsaurus text-xs p-3 flex items-center justify-between gap-2 border-t border-gray-100"
                                                                    })
                                                              ],
                                                              className: "rounded-lg border overflow-hidden cursor-pointer transition-shadow hover:shadow-md " + (
                                                                Survey$ReactHooksTemplate.id(selectedTemplate) === template.id ? "border-pigmentblue ring-2 ring-pigmentblue ring-opacity-30" : "border-gray-200"
                                                              )
                                                            }, String(Belt_Option.getWithDefault(template.id, 0)));
                                                }))),
                                      className: "grid grid-cols-1 sm:grid-cols-2 gap-4"
                                    })
                              ],
                              className: "px-5 py-5 sm:px-6 sm:py-6"
                            }) : JsxRuntime.jsx(ModalFormLayout$ReactHooksTemplate.SurveyFields.make, {
                              name: Survey$ReactHooksTemplate.name(survey),
                              nameError: nameError,
                              isQuizModeActive: isQuizModeActive,
                              onNameChange: handleNameChange,
                              onCategoryToggle: handleCategoryToggle
                            }),
                      footer: templatePage ? JsxRuntime.jsx(ModalFormLayout$ReactHooksTemplate.TemplateFooter.make, {
                              onBack: (function (param) {
                                  Curry._1(setTemplatePage, (function (param) {
                                          return false;
                                        }));
                                }),
                              onCreateFromScratch: (function (param) {
                                  var params = {};
                                  params["survey"] = Survey$ReactHooksTemplate.toJson(survey);
                                  Js_promise.then_((function (response) {
                                          var status = Json_decode.field("status", (function (param) {
                                                  return Json_decode.withDefault("failed", Json_decode.string, param);
                                                }), response);
                                          if (status === "success") {
                                            var createdSurvey = Json_decode.field("survey", Survey$ReactHooksTemplate.fromJson, response);
                                            var x = createdSurvey.id;
                                            if (x !== undefined) {
                                              RescriptReactRouter.push("/projects/" + (String(projectId) + ("/surveys/edit/" + String(x))));
                                            } else {
                                              Curry._1(toggleSurveyCreate, undefined);
                                            }
                                          } else {
                                            Curry._1(setErrors, (function (param) {
                                                    return "Something went wrong. Please contact admin";
                                                  }));
                                          }
                                          return Promise.resolve();
                                        }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/projects/" + String(projectId) + "/surveys", params));
                                }),
                              onChooseTemplate: (function (param) {
                                  var templateId = Survey$ReactHooksTemplate.id(selectedTemplate);
                                  console.log("Testtt");
                                  var params = {};
                                  params["survey"] = Survey$ReactHooksTemplate.toJson(survey);
                                  params["template_id"] = String(Belt_Option.getExn(templateId));
                                  Js_promise.then_((function (response) {
                                          var status = Json_decode.field("status", (function (param) {
                                                  return Json_decode.withDefault("failed", Json_decode.string, param);
                                                }), response);
                                          console.log(response);
                                          if (status === "success") {
                                            var createdSurvey = Json_decode.field("survey", Survey$ReactHooksTemplate.fromJson, response);
                                            var x = createdSurvey.id;
                                            if (x !== undefined) {
                                              RescriptReactRouter.push("/projects/" + (String(projectId) + ("/surveys/edit/" + String(x))));
                                            } else {
                                              Curry._1(toggleSurveyCreate, undefined);
                                            }
                                          } else {
                                            Curry._1(setErrors, (function (param) {
                                                    return "Something went wrong. Please contact admin";
                                                  }));
                                          }
                                          return Promise.resolve();
                                        }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/projects/" + String(projectId) + "/create_from_template", params));
                                }),
                              templateSelected: match$5[0]
                            }) : JsxRuntime.jsx(ModalFormLayout$ReactHooksTemplate.make, {
                              onDiscard: (function (param) {
                                  Curry._1(toggleSurveyCreate, undefined);
                                }),
                              onPrimary: (function (param) {
                                  Curry._1(setTemplatePage, (function (param) {
                                          return true;
                                        }));
                                }),
                              primaryLabel: "Next",
                              primaryDisabled: Survey$ReactHooksTemplate.name(survey).length === 0 || nameError
                            })
                    })
              ]
            });
}

var make = SurveyCreate;

exports.decodeSurvey = decodeSurvey;
exports.make = make;
/* react Not a pure module */
